import styled from "styled-components";
import { breakPoints } from "../../../common/styles";

export const Container = styled.section`
  @media (max-width: 991px) {
    .container {
      padding: 0;
    }
  }
`;

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 20px;
  margin-bottom: 50px;
`;

export const ArticleBox = styled.article`
  cursor: pointer;
  border: 1px solid #ececec;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  & a {
    color: #1b1b1b;
    :hover {
      color: #3bb77e;
    }
  }
  .img_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 150px;
  }

  .content_wrapper {
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .post_title {
      margin-bottom: 10px;
    }
    .post_desc {
      margin-bottom: 10px;
      word-break: keep-all;
    }
    .post_summary {
      font-size: 12px;
      line-height: 1.3;
      color: #b0b0b0;
    }
    .post_date {
      display: flex;
      align-items: center;
      & i {
        margin-right: 5px;
        margin-top: 2px;
      }
    }
  }

  @media (${breakPoints.tablet}) {
    .img_wrapper {
      max-width: 200px;
    }
  }
  @media (${breakPoints.mobile}) {
    border: none;
    border-bottom: 1px solid #ececec;
    border-radius: 0;
    padding-bottom: 10px;
    .post_summary {
      display: none;
    }
  }
  @media (${breakPoints.xs_mobile}) {
    .img_wrapper {
      max-width: 130px;
    }
    .content_wrapper {
      padding: 10px;
    }
    .post_title {
      font-size: 16px;
    }
    .post_desc {
      font-size: 14px;
    }
    .post_summary {
      display: none;
    }
    .post_date {
      font-size: 12px;
    }
  }
`;
